import type { Company } from '@nova/shared';
import { NovaOrb } from './NovaOrb.js';

/**
 * A small, deliberately quiet mark in the corner of a card, so you can tell a
 * Spama post from a Prokom post at a glance without it shouting. Anything that is
 * not clearly one company (BEGGE, or unknown) falls back to the Nova mark.
 *
 * The wordmarks are placeholders — drop the real Spama/Prokom logos in here when
 * we have them; the Nova default is the accent dot for now.
 */
export function CompanyMark({ company }: { company?: Company }) {
  if (company === 'SPAMA' || company === 'PROKOM') {
    return (
      <span className="text-ink-soft/45 font-display text-[9px] font-medium tracking-wide select-none">
        {company === 'SPAMA' ? 'Spama' : 'Prokom'}
      </span>
    );
  }
  // Default / BEGGE → the Nova mark.
  return <NovaOrb size={6} animate={false} />;
}
